import Api from './rest/CrmRejectionReasonApi';

export default new Api();
